import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // <-- LÍNEA NUEVA

const firebaseConfig = {
  apiKey: "AIzaSyAhtuQffUfQzsv0nrilBv1rpjrinysC7pY",
  authDomain: "atlantisfish-2e102.firebaseapp.com",
  projectId: "atlantisfish-2e102",
  storageBucket: "atlantisfish-2e102.appspot.com",
  messagingSenderId: "387286304681",
  appId: "1:387286304681:web:541672b49fb06c6b0f66b8"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);   // <-- LÍNEA NUEVA
